(function () {
  var form = document.getElementById("dm-cart-form");
  if (!form) return;

  var isLocalPreview = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
  var syncTimer = null;

  function clampQty(value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 0) return 0;
    return n;
  }

  var currency = form.dataset.currency || "USD";
  function formatMoney(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: currency }).format(cents / 100) + " " + currency;
  }

  function getRows() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-cart-item]"));
  }

  function updateCountDisplay(count) {
    var countEl = document.querySelector("[data-cart-count-value]");
    if (countEl) countEl.textContent = String(count);
  }

  function recalculate() {
    var rows = getRows();
    var total = 0;
    var count = 0;

    rows.forEach(function (row) {
      var input = row.querySelector(".dm-cart-item__qty-input");
      var unit = parseInt(row.getAttribute("data-unit-price"), 10) || 0;
      var qty = clampQty(input ? input.value : 0);
      var lineTotal = unit * qty;

      total += lineTotal;
      count += qty;

      var lineEl = row.querySelector("[data-cart-line-price]");
      if (lineEl) lineEl.textContent = formatMoney(lineTotal);
    });

    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = formatMoney(total);

    updateCountDisplay(count);
    return { total: total, count: count };
  }

  function applyCartResponse(cart) {
    if (!cart || !cart.item_count) {
      window.location.reload();
      return;
    }

    currency = cart.currency || currency;
    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    updateCountDisplay(cart.item_count);

    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item, index) {
        var row = document.querySelector('[data-cart-item][data-line="' + (index + 1) + '"]');
        if (!row) return;
        var input = row.querySelector(".dm-cart-item__qty-input");
        if (input) input.value = String(item.quantity);
        var lineEl = row.querySelector("[data-cart-line-price]");
        if (lineEl) lineEl.textContent = formatMoney(item.final_line_price);
      });
    }
  }

  function syncLine(line, quantity) {
    recalculate();

    if (isLocalPreview) {
      if (quantity === 0) {
        var row = document.querySelector('[data-cart-item][data-line="' + line + '"]');
        if (row) row.remove();
        if (getRows().length === 0) window.location.reload();
        else recalculate();
      }
      return Promise.resolve();
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart update failed");
        return response.json();
      })
      .then(function (cart) {
        if (!cart.item_count || quantity === 0) {
          window.location.reload();
          return;
        }
        applyCartResponse(cart);
      })
      .catch(function () {
        window.alert("Could not update your cart. Please try again.");
      });
  }

  function queueSync(line, quantity) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncLine(line, quantity);
    }, 250);
  }

  document.querySelectorAll("[data-cart-qty]").forEach(function (wrap) {
    var row = wrap.closest("[data-cart-item]");
    var input = wrap.querySelector(".dm-cart-item__qty-input");
    var minus = wrap.querySelector("[data-cart-qty-minus]");
    var plus = wrap.querySelector("[data-cart-qty-plus]");
    if (!row || !input || !minus || !plus) return;

    var line = parseInt(row.getAttribute("data-line"), 10);

    function setQuantity(nextQty) {
      var qty = clampQty(nextQty);
      input.value = String(qty);
      recalculate();
      queueSync(line, qty);
    }

    minus.addEventListener("click", function () {
      setQuantity(clampQty(input.value) - 1);
    });

    plus.addEventListener("click", function () {
      setQuantity(clampQty(input.value) + 1);
    });

    input.addEventListener("change", function () {
      setQuantity(input.value);
    });

    input.addEventListener("input", function () {
      recalculate();
    });
  });

  document.querySelectorAll("[data-cart-remove]").forEach(function (button) {
    button.addEventListener("click", function () {
      var row = button.closest("[data-cart-item]");
      if (!row) return;
      var line = parseInt(row.getAttribute("data-line"), 10);
      var input = row.querySelector(".dm-cart-item__qty-input");
      if (input) input.value = "0";
      syncLine(line, 0);
    });
  });

  recalculate();
})();
